import { axiosInstance } from "@/use/utilities/axios/app/axios-instance";

export async function downloadProject(projectId) {
  const axios = axiosInstance().primoLab;
  try {
    const response = await axios.get(`/projects/download`, {
      params: {
        project_id: projectId,
      },
    });
    const downloadUrl = response.data.data.download_url;
    const fileName = response.data.data.file_name;
    const message = response.data.data.message;
    return { downloadUrl, fileName, message };
  } catch (error) {
    throw error.response?.data?.errors || ['An unexpected error occurred'];
  }
}
